<!-- Offers carousel + hint bubble, stacked above whichever launcher is visible -->
@if (showStack()) {
<div class="sp-support-stack" [class.sp-support-stack--zendesk]="!onLauncherRoute()">
@if (showOffers()) {
  <app-offers-carousel></app-offers-carousel>
}
<!-- Hint bubble over the Zendesk launcher (shown off our launcher route) -->
@if (showZendeskHint()) {
  <div
    class="sp-support-hint sp-support-hint--zendesk"
    role="status"
    aria-live="polite"
  >
    <button
      type="button"
      class="sp-support-hint__close"
      (click)="$event.stopPropagation(); dismissZendeskHint()"
      aria-label="Cerrar mensaje"
    >×</button>
    <button
      type="button"
      class="sp-support-hint__action"
      (click)="openZendeskHint()"
      aria-label="Abrir chat de soporte"
    >
      <span class="sp-support-hint__title">¿Necesitas ayuda?</span>
      <span class="sp-support-hint__text">
        Presione el botón para contactar a soporte.
      </span>
    </button>
    <span class="sp-support-hint__tail" aria-hidden="true"></span>
  </div>
}

<!-- Hint bubble over our own launcher -->
@if (showHint()) {
  <div class="sp-support-hint" role="status" aria-live="polite">
    <button
      type="button"
      class="sp-support-hint__close"
      (click)="dismissHint()"
      aria-label="Cerrar mensaje"
    >×</button>
    <span class="sp-support-hint__title">¿Necesitas ayuda?</span>
    <span class="sp-support-hint__text">
      Presione el botón para contactar a soporte.
    </span>
    <span class="sp-support-hint__tail" aria-hidden="true"></span>
  </div>
}
</div>
}

<!-- Floating launcher button -->
@if (onLauncherRoute()) {
<button
  type="button"
  class="sp-support-launcher"
  [class.hidden]="store.widgetOpen() || !visible()"
  (click)="toggle()"
  aria-label="Abrir chat de soporte"
>
  @if (store.unreadCount() > 0) {
    <span class="sp-support-launcher__pulse"></span>
  }
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" fill-rule="evenodd" d="m13.087 21.388l.542-.916c.42-.71.63-1.066.968-1.262c.338-.197.763-.204 1.613-.219c1.256-.021 2.043-.098 2.703-.372a5 5 0 0 0 2.706-2.706C22 14.995 22 13.83 22 11.5v-1c0-3.273 0-4.91-.737-6.112a5 5 0 0 0-1.65-1.651C18.41 2 16.773 2 13.5 2h-3c-3.273 0-4.91 0-6.112.737a5 5 0 0 0-1.651 1.65C2 5.59 2 7.228 2 10.5v1c0 2.33 0 3.495.38 4.413a5 5 0 0 0 2.707 2.706c.66.274 1.447.35 2.703.372c.85.015 1.275.022 1.613.219c.337.196.548.551.968 1.262l.542.916c.483.816 1.69.816 2.174 0M16 12a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-3-1a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-5 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2" clip-rule="evenodd"/></svg>
  @if (store.unreadCount() > 0) {
    <span
      class="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[11px] font-bold border-2 border-white"
      aria-label="Mensajes sin leer"
    >
      {{ store.unreadCount() > 99 ? '99+' : store.unreadCount() }}
    </span>
  }
</button>

<!-- Floating chat container -->
<div class="sp-support-frame" [class.open]="store.widgetOpen()">
  <app-support-chat
    *ngIf="store.widgetOpen()"
    [embedded]="true"
    (close)="close()"
  ></app-support-chat>
</div>
}
